/* eslint-disable no-unused-vars */
export enum ClubMemberRoles {
  CLUB_ADMIN = 0,
  CLUB_CONTRIBUTOR = 1,
  CLUB_VIEWER = 2,
}
